import { render, staticRenderFns } from "./banner_v3.vue?vue&type=template&id=49c55a5f&"
import script from "./banner_v3.vue?vue&type=script&lang=js&"
export * from "./banner_v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports